import actions from './actions'
import mutations from './mutations'

const leader = {
    namespaced: true,
    state: {
        items: [],
        pagination: {
            page: 1,
            length: null,
            total: null
        },
        filters: {
            leaderId: null,
            fromDate: null,
            toDate: null,
            leaderEmail: null,
            query: null
        },
        isLoaded: true
    },
    mutations,
    actions
}

export default leader
